'use strict';

/**
 *  Load modules
 */
import '../../scss/form.scss';
(function ($) {
  gform.addFilter('gform_datepicker_options_pre_init', function (optionsObj, formId, fieldId) {
    // Apply to field 2 only 
    if ((formId = 3) && fieldId == 9) {
      optionsObj.maxDate = 0;
    }
    if ((formId = 3) && fieldId == 103) {
      optionsObj.minDate = 0;
    }
    if ((formId = 3) && fieldId == 81) {
      optionsObj.minDate = 0;
    }
    if ((formId = 6) && fieldId == 6) {
      optionsObj.maxDate = 0;
    }
    if ((formId = 6) && fieldId == 39) {
      optionsObj.minDate = 0;
    }
    return optionsObj;
  });
  $(document).bind("gform_post_render", function () {
    if ($(".form").length > 0) {
      /* Email Validation */
      var validateEmail = function validateEmail($email) {
        var emailReg = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        return emailReg.test($email);
      };
      var toSentenceCase = function toSentenceCase(value) {
        var val = value.split(' ');
        for (var i = 0, l = val.length; i < l; i++) {
          val[i] = val[i].charAt(0).toUpperCase() + val[i].substr(1);
        }
        return val.join(' ');
      };
      //insert resume name in to hidden input
      /*let resumeValue = $('#input_3_58').val();
      $(document).on("change", '#input_3_58', function(){
          resumeValue = $(this).val().replace(/^.*[\\\/]/, '');
          $('#input_3_158').val(resumeValue);
      });
      $(document).on("click", '[data-name="#input_3_58"], .gform_delete_file', function(){
          $('#input_3_158').val('');
      });*/
      var syncFileInput = function syncFileInput(fileInputSelector, hiddenInputSelector) {
        var resumeValue = $(fileInputSelector).val();
        $(document).on("change", fileInputSelector, function () {
          resumeValue = $(this).val().replace(/^.*[\\\/]/, '');
          $(hiddenInputSelector).val(resumeValue);
        });
        $(document).on("click", "[data-name=\"".concat(fileInputSelector, "\"], .gform_delete_file"), function () {
          $(hiddenInputSelector).val('');
        });
      }; // Виклик для першої пари:
      var autocomplete = function autocomplete(inp, arr) {
        /*the autocomplete function takes two arguments,
        the text field element and an array of possible autocompleted values:*/
        var currentFocus;
        /*execute a function when someone writes in the text field:*/
        inp.addEventListener("input", function (e) {
          var a,
            b,
            i,
            val = this.value;
          /*close any already open lists of autocompleted values*/
          closeAllLists();
          if (!val) {
            return false;
          }
          currentFocus = -1;
          /*create a DIV element that will contain the items (values):*/
          a = document.createElement("DIV");
          a.setAttribute("id", this.id + "autocomplete-list");
          a.setAttribute("class", "autocomplete-items");
          /*append the DIV element as a child of the autocomplete container:*/
          this.parentNode.appendChild(a);
          /*for each item in the array...*/
          for (i = 0; i < arr.length; i++) {
            /*check if the item starts with the same letters as the text field value:*/
            if (arr[i].substr(0, val.length).toUpperCase() == val.toUpperCase()) {
              /*create a DIV element for each matching element:*/
              b = document.createElement("DIV");
              /*make the matching letters bold:*/
              b.innerHTML = "<strong>" + arr[i].substr(0, val.length) + "</strong>";
              b.innerHTML += arr[i].substr(val.length);
              /*insert a input field that will hold the current array item's value:*/
              b.innerHTML += "<input type='hidden' value='" + arr[i] + "'>";
              /*execute a function when someone clicks on the item value (DIV element):*/
              b.addEventListener("click", function (e) {
                /*insert the value for the autocomplete text field:*/
                inp.value = this.getElementsByTagName("input")[0].value;
                /*close the list of autocompleted values,
                (or any other open lists of autocompleted values:*/
                closeAllLists();
              });
              a.appendChild(b);
            }
          }
        });
        /*execute a function presses a key on the keyboard:*/
        inp.addEventListener("keydown", function (e) {
          var x = document.getElementById(this.id + "autocomplete-list");
          if (x) x = x.getElementsByTagName("div");
          if (e.keyCode == 40) {
            /*If the arrow DOWN key is pressed,
            increase the currentFocus variable:*/
            currentFocus++;
            /*and and make the current item more visible:*/
            addActive(x);
          } else if (e.keyCode == 38) {
            //up
            /*If the arrow UP key is pressed,
            decrease the currentFocus variable:*/
            currentFocus--;
            /*and and make the current item more visible:*/
            addActive(x);
          } else if (e.keyCode == 13) {
            /*If the ENTER key is pressed, prevent the form from being submitted,*/
            e.preventDefault();
            if (currentFocus > -1) {
              /*and simulate a click on the "active" item:*/
              if (x) x[currentFocus].click();
            }
          }
        });
        function addActive(x) {
          /*a function to classify an item as "active":*/
          if (!x) return false;
          /*start by removing the "active" class on all items:*/
          removeActive(x);
          if (currentFocus >= x.length) currentFocus = 0;
          if (currentFocus < 0) currentFocus = x.length - 1;
          /*add class "autocomplete-active":*/
          x[currentFocus].classList.add("autocomplete-active");
        }
        function removeActive(x) {
          /*a function to remove the "active" class from all autocomplete items:*/
          for (var i = 0; i < x.length; i++) {
            x[i].classList.remove("autocomplete-active");
          }
        }
        function closeAllLists(elmnt) {
          /*close all autocomplete lists in the document,
          except the one passed as an argument:*/
          var x = document.getElementsByClassName("autocomplete-items");
          for (var i = 0; i < x.length; i++) {
            if (elmnt != x[i] && elmnt != inp) {
              x[i].parentNode.removeChild(x[i]);
            }
          }
        }
        /*execute a function when someone clicks in the document:*/
        document.addEventListener("click", function (e) {
          closeAllLists(e.target);
        });
      };
      /*An array containing all the country names in the world:*/
      // The autocomplete function for states
      var autocomplete2 = function autocomplete2(inp, arr) {
        var currentFocus = -1;
        inp.addEventListener("input", function () {
          var val = this.value;
          closeAllLists();
          if (!val) return false;
          currentFocus = -1;
          var a = document.createElement("DIV");
          a.setAttribute("id", this.id + "autocomplete-list");
          a.setAttribute("class", "autocomplete-items");
          this.parentNode.appendChild(a);
          arr.forEach(function (item) {
            if (item.name.toUpperCase().startsWith(val.toUpperCase()) || item.abbreviation.toUpperCase().startsWith(val.toUpperCase())) {
              var b = document.createElement("DIV");
              b.innerHTML = "<strong>" + item.name.substr(0, val.length) + "</strong>";
              b.innerHTML += item.name.substr(val.length) + " (" + item.abbreviation + ")";
              b.innerHTML += "<input type='hidden' value='" + item.name + "'>";
              b.addEventListener("click", function () {
                inp.value = this.getElementsByTagName("input")[0].value;
                closeAllLists();
              });
              a.appendChild(b);
            }
          });
        });
        inp.addEventListener("keydown", function (e) {
          var x = document.getElementById(this.id + "autocomplete-list");
          if (x) x = x.getElementsByTagName("div");
          if (e.key === "ArrowDown") {
            currentFocus++;
            addActive(x);
          } else if (e.key === "ArrowUp") {
            currentFocus--;
            addActive(x);
          } else if (e.key === "Enter") {
            e.preventDefault();
            if (currentFocus > -1 && x && x[currentFocus]) {
              x[currentFocus].click();
            } else if (x && x.length > 0) {
              x[0].click(); // fallback: select first item
            }
          }
        });

        function addActive(x) {
          if (!x) return false;
          removeActive(x);
          if (currentFocus >= x.length) currentFocus = 0;
          if (currentFocus < 0) currentFocus = x.length - 1;
          x[currentFocus].classList.add("autocomplete-active");
        }
        function removeActive(x) {
          Array.from(x).forEach(function (el) {
            return el.classList.remove("autocomplete-active");
          });
        }
        function closeAllLists(elmnt) {
          var x = document.getElementsByClassName("autocomplete-items");
          for (var i = 0; i < x.length; i++) {
            if (elmnt !== x[i] && elmnt !== inp) {
              x[i].parentNode.removeChild(x[i]);
            }
          }
        }
        document.addEventListener("click", function (e) {
          closeAllLists(e.target);
        });
      }; // setupStateInput
      var setupStateInput = function setupStateInput(inputId) {
        var inputEl = document.getElementById(inputId);
        if (!inputEl) return;
        autocomplete2(inputEl, usStates);
        inputEl.addEventListener("click", function () {
          this.select();
        });
        function checkInputValue() {
          var inputValue = inputEl.value.trim();
          var match = usStates.some(function (state) {
            return state.name.toLowerCase() === inputValue.toLowerCase();
          });
          if (!match) {
            inputEl.value = '';
          }
        }
        inputEl.addEventListener('blur', checkInputValue);
        $(inputEl).on('keydown', function (e) {
          if (e.key === 'Enter' || e.keyCode === 13) {
            checkInputValue();
          }
        });
        checkInputValue();
      }; // Ініціалізація для кількох полів:
      var $gform_wrapper = $('.gform_wrapper');
      $(".form input, .form textarea").on("focusin", function () {
        $(this).closest(".gfield").addClass("gfield--infocus");
      });
      $(".form input, .form textarea").on("focusout", function () {
        $(this).closest(".gfield").removeClass("gfield--infocus");
        var inputValue = $(this).val();
        if (inputValue) {
          $(this).closest(".gfield").addClass("gfield--changed");
          if ($(this).closest(".gfield").hasClass("gfield_contains_required")) {
            $(this).closest(".gfield").removeClass("gfield_error");
          }
          if ($(this).closest(".gfield").find('label').text() === 'Zip Code*' && inputValue.includes('_')) {
            $(this).closest(".gfield").removeClass("gfield--changed");
            $(this).closest(".gfield").addClass("gfield_error");
          } else {
            $(this).closest(".gfield").addClass("gfield--changed");
            $(this).closest(".gfield").removeClass("gfield_error");
          }
        } else {
          $(this).closest(".gfield").removeClass("gfield--changed");
          if ($(this).closest(".gfield").hasClass("gfield_contains_required")) {
            $gform_wrapper.addClass("gform_validation_error");
            $(this).closest(".gfield").addClass("gfield_error");
          }
        }
      });
      $(".form .email input").on("focusout", function () {
        var inputValue = $(this).val();
        if (!validateEmail(inputValue)) {
          $gform_wrapper.addClass("gform_validation_error");
          $(this).closest(".gfield").addClass("gfield_error");
        }
      });

      //prevent input letters in phone field
      if ($(".form .phone input").length > 0) {
        document.querySelector('.form .phone input').addEventListener('keypress', function (e) {
          var regex = new RegExp("^[0-9-+()]");
          var key = String.fromCharCode(e.charCode ? e.which : e.charCode);
          if (!regex.test(key)) {
            e.preventDefault();
            return false;
          }
        }, {
          passive: false,
          capture: true
        });
      }

      //Auto Capitalize every new word on input
      $(document).on("input", ".auto-capitalize input", function () {
        var words = this.value.split(' ');
        for (var i = 0; i < words.length; i++) {
          if (words[i].length > 0) {
            words[i] = words[i][0].toUpperCase() + words[i].substring(1);
          }
        }
        this.value = words.join(' ');
      });

      //format date
      if ($(".formatDateTextBox input").length > 0) {
        var applyDateMask = function applyDateMask(event) {
          var input = event.target;
          var value = input.value;

          // Remove any non-digit characters
          var cleanValue = value.replace(/\D/g, '');

          // Add slashes at the appropriate positions
          if (cleanValue.length >= 2) {
            cleanValue = cleanValue.substring(0, 2) + '/' + cleanValue.substring(2);
          }
          if (cleanValue.length >= 5) {
            cleanValue = cleanValue.substring(0, 5) + '/' + cleanValue.substring(5);
          }
          if (cleanValue.length >= 10) {
            cleanValue = cleanValue.slice(0, 10);
          }

          // Update the input value with the masked date
          input.value = cleanValue;
        }; // Attach the event listener to your date input
        var dateInput1 = document.getElementById('input_3_9'),
          dateInput2 = document.getElementById('input_3_81'),
          dateInput3 = document.getElementById('input_3_103'),
          dateInput4 = document.getElementById('input_6_6');
        if (dateInput1) {
          dateInput1.addEventListener('input', applyDateMask);
        }
        if (dateInput2) {
          dateInput2.addEventListener('input', applyDateMask);
        }
        if (dateInput3) {
          dateInput3.addEventListener('input', applyDateMask);
        }
        if (dateInput4) {
          dateInput4.addEventListener('input', applyDateMask);
        }
      }

      //validateYearTextBox
      $(document).on("input", ".validateYearTextBox input", function () {
        var value = this.value;
        value = value.replace(/\D/g, '');
        $(this).val(value.slice(0, 4));
      });

      //validateGrossTextBox
      $(document).on("input", ".validateGrossTextBox input", function () {
        var value = this.value;
        value = value.replace(/\D/g, '');
        $(this).val(value.slice(0, 4));
      });
      $(document).on("focusout", ".validateGrossTextBox input", function () {
        var value = this.value;
        value = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        $(this).val(value);
      });

      //disable numbers for inputs
      $(document).on("input", ".disableNumbers input", function () {
        var value = this.value;
        value = value.replace(/[0-9]/g, '');
        $(this).val(value);
      });

      //all words in sentence case
      var $input = $('.wordsSentenceCase input');
      $input.on('blur', function (e) {
        var $this = $(this);
        $this.val(toSentenceCase($this.val()));
      });

      // validation-characters
      if ($(".validation-characters-10 textarea").length > 0) {
        $('.validation-characters-10').append('<div class="gfield_description validation_message gfield_validation_message-custom">Please enter at least 10 characters.</div>');
        $('.validation-characters-10').addClass('hide-error-custom');
        $(document).on('input', '.validation-characters-10 textarea', function () {
          var value = this.value,
            symbolsCount = value.length;
          if (symbolsCount < 10) {
            $(this).closest('.gfield').addClass('show-error');
            $(this).closest('.gfield').removeClass('hide-error');
            $(this).closest('.gfield').addClass('show-error-custom');
          } else {
            $(this).closest('.gfield').removeClass('show-error');
            $(this).closest('.gfield').addClass('hide-error');
            $(this).closest('.gfield').removeClass('show-error-custom');
          }
        });
      }
      if ($(".validation-characters-20 textarea").length > 0) {
        $('.validation-characters-20').append('<div class="gfield_description validation_message gfield_validation_message-custom">Please enter at least 20 characters.</div>');
        $('.validation-characters-20').addClass('hide-error-custom');
        $(document).on('input', '.validation-characters-20 textarea', function () {
          var value = this.value,
            symbolsCount = value.length;
          if (symbolsCount < 20) {
            $(this).closest('.gfield').addClass('show-error');
            $(this).closest('.gfield').removeClass('hide-error');
            $(this).closest('.gfield').addClass('show-error-custom');
          } else {
            $(this).closest('.gfield').removeClass('show-error');
            $(this).closest('.gfield').addClass('hide-error');
            $(this).closest('.gfield').removeClass('show-error-custom');
          }
        });
      }
      if ($(".validation-characters-50 textarea").length > 0) {
        $('.validation-characters-50').append('<div class="gfield_description validation_message gfield_validation_message-custom">Please enter at least 50 characters.</div>');
        $('.validation-characters-50').addClass('hide-error-custom');
        $(document).on('input', '.validation-characters-50 textarea', function () {
          var value = this.value,
            symbolsCount = value.length;
          if (symbolsCount < 50) {
            $(this).closest('.gfield').addClass('show-error');
            $(this).closest('.gfield').removeClass('hide-error');
            $(this).closest('.gfield').addClass('show-error-custom');
          } else {
            $(this).closest('.gfield').removeClass('show-error');
            $(this).closest('.gfield').addClass('hide-error');
            $(this).closest('.gfield').removeClass('show-error-custom');
          }
        });
      }
      $(".form input:not([type='file']), .form textarea").each(function () {
        $(this).closest(".gfield").removeClass("gfield--infocus");
        if ($(this).val()) {
          $(this).closest(".gfield").addClass("gfield--changed");
        } else {
          $(this).closest(".gfield").removeClass("gfield--changed");
        }
      });
      // Resolve bug with file uploading
      if ($(".form .uploadfile").length > 0 && $(".form .uploadfile").hasClass('gfield_error')) {
        $(".form .gfield_error").find(".gform_delete").click();
      }
      $(document).on("click", '.form .uploadfile [type="file"]', function () {
        $(this).val(''); //fix for bug: HTML input file selection event not firing upon selecting the same file
      });

      $(document).on("click", '.attach-remove', function () {
        $($(this).data("name")).val(''); //remove uploaded value
      });

      $(document).on("change", '.form .uploadfile [type="file"]', function () {
        var $form = $(this).closest(".form"),
          value = $(this).val().replace(/^.*[\\\/]/, ''),
          $attachText = $(this).closest(".uploadfile").find($('.attach-text')),
          $attachRemove = $(this).closest(".uploadfile").find($('.attach-remove')),
          formID = $form.find('form').attr('id').match(/(\d+)/)[0],
          fieldID = $(this).attr('name').match(/(\d+)/)[0];
        $(this).parents('.gfield ').find('.gfield_fileupload_filename').text('');
        $(this).parents('.gfield ').removeClass('gfield_error');
        if ($attachText.length > 0) {
          $attachRemove.addClass('showed');
          $attachText.text(value);
          if (value === '') {
            $attachRemove.removeClass('showed');
          }
        } else {
          $(this).closest(".uploadfile").find($('.ginput_container_fileupload')).append($('<div>').append($('<div class="ginput_preview">').append($('<span class="attach-remove showed">').attr('data-name', '#input_' + formID + '_' + fieldID + '').attr('onclick', 'gformDeleteUploadedFile(' + formID + ',' + fieldID + ', this)')).append($('<span class="attach-text">').text(value))));
        }
      });
      syncFileInput('#input_3_58', '#input_3_158');

      // Виклик для другої пари:
      syncFileInput('#input_6_41', '#input_6_46'); // припустимо, що приховане поле має ID input_6_146

      //insert video name in to hidden input
      var videoValue = $('#input_3_156').val();
      $(document).on("change", '#input_3_156', function () {
        videoValue = $(this).val().replace(/^.*[\\\/]/, '');
        $('#input_3_160').val(videoValue);
      });
      $(document).on("click", '[data-name="#input_3_156"], .gform_delete_file', function () {
        $('#input_3_160').val('');
      });

      //insert phone number in to hidden input
      $(document).on("focusout", "#input_3_70", function () {
        $('#input_3_159').val(this.value);
      });
      $(document).on("focusout", "#input_6_8", function () {
        $('#input_6_44').val(this.value);
      });
      $(document).on("focusout", "#input_6_15", function () {
        $('#input_6_45').val(this.value);
      });
      if ($(".form").length > 0) {
        var autosize = function autosize() {
          var el = this;
          setTimeout(function () {
            el.style.cssText = 'height:' + el.scrollHeight + 'px';
          }, 0);
        };
        var textarea = $('.form .textarea');
        textarea.on('keydown', autosize);
      }

      //presubmit popup
      if ($('.gf_step_active .gf_step_number').text() == $('.gf_step_last .gf_step_number').text()) {
        $('.form__confirmation-btn').show();
      } else {
        $('.form__confirmation-btn').hide();
      }
      $('.form__confirmation-btn').click(function () {
        $('.popup').addClass('open');
      });
      $("#career-form-submit").click(function () {
        $('.popup').removeClass('open');
        $('#gform_submit_button_3').click();
      });
      // Change design of all selects after submit gravity form
      if ($('.form select').length) {
        var checkIfNext = function checkIfNext() {
          if (validDriverLicense && haveLegalRight) {
            $('.gform_page_footer').removeClass('disabled');
          } else {
            $('.gform_page_footer').addClass('disabled');
          }
        };
        var haveLegalRight = true;
        var validDriverLicense = true;
        $('.form select').selectric({
          maxHeight: 340,
          onChange: function onChange() {
            $(this).closest('.selectric-wrapper').addClass('selectric-changed');
            if ($(this)[0].id == 'input_3_24') {
              if ($(this).val() == 'Scooter/Bike' || $(this).val() == 'Sedan' || $(this).val() == 'SUV' || $(this).val() == 'Van' || $(this).val() == 'Truck') {
                $('#field_3_26').show();
                $('#field_3_27').show();
                $('#field_3_28').show();
                $('#input_3_26').prop('disabled', false);
                $('#input_3_27').prop('disabled', false);
                $('#input_3_28').prop('disabled', false);
              } else {
                $('#field_3_26').hide();
                $('#field_3_27').hide();
                $('#field_3_28').hide();
                $('#input_3_26').prop('disabled', true);
                $('#input_3_27').prop('disabled', true);
                $('#input_3_28').prop('disabled', true);
              }
            }
            if ($(this)[0].id == 'input_3_74') {
              if ($(this).val() == 'Scooter/Bike' || $(this).val() == 'Sedan' || $(this).val() == 'SUV' || $(this).val() == 'Van' || $(this).val() == 'Truck') {
                $('#field_3_76').show();
                $('#field_3_77').show();
                $('#field_3_78').show();
                $('#input_3_76').prop('disabled', false);
                $('#input_3_77').prop('disabled', false);
                $('#input_3_78').prop('disabled', false);
              } else {
                $('#field_3_76').hide();
                $('#field_3_77').hide();
                $('#field_3_78').hide();
                $('#input_3_76').prop('disabled', true);
                $('#input_3_77').prop('disabled', true);
                $('#input_3_78').prop('disabled', true);
              }
            }
            //Do you have active auto insurance?
            if ($(this)[0].id == 'input_3_29') {
              if ($(this).val() == 'Yes') {
                $('#field_3_80').show();
                $('#field_3_81').show();
                $('#input_3_80').prop('disabled', false);
                $('#input_3_81').prop('disabled', false);
                $(this).closest('.gfield').addClass('has-insurance');
              } else {
                $('#field_3_80').hide();
                $('#field_3_81').hide();
                $('#input_3_80').prop('disabled', true);
                $('#input_3_81').prop('disabled', true);
                $(this).closest('.gfield').removeClass('has-insurance');
              }
            }
            //Other Auto Policy Insurer
            if ($(this)[0].id == 'input_3_80') {
              if ($(this).val() == 'Other') {
                $('#field_3_82').show();
                $('#input_3_82').prop('disabled', false);
              } else {
                $('#field_3_82').hide();
                $('#input_3_82').prop('disabled', true);
              }
            }

            //Do you have any delivery experience? (0-10+)
            if ($(this)[0].id == 'input_3_93') {
              if ($(this).val() != '0 years') {
                $('#field_3_94').show();
                $('#input_3_94').prop('disabled', false);
                $(this).closest('.gfield').addClass('has-experience');
              } else {
                $('#field_3_94').hide();
                $('#input_3_94').prop('disabled', true);
                $(this).closest('.gfield').removeClass('has-experience');
              }
            }

            //Do you have Medical Courier experience?
            if ($(this)[0].id == 'input_3_36') {
              if ($(this).val() != '0 years') {
                $('#field_3_63').show();
                $('#input_3_63').prop('disabled', false);
              } else {
                $('#field_3_63').hide();
                $('#input_3_63').prop('disabled', true);
              }
            }

            //Can you provide a professional reference who can vouch for your character & work ethic?*
            if ($(this)[0].id == 'input_3_107') {
              if ($(this).val() == 'Yes') {
                $('#field_3_108').show();
                $('#field_3_109').show();
                $('#field_3_110').show();
                $('#input_3_108').prop('disabled', false);
                $('#input_3_109').prop('disabled', false);
                $('#input_3_110').prop('disabled', false);
              } else {
                $('#field_3_108').hide();
                $('#field_3_109').hide();
                $('#field_3_110').hide();
                $('#input_3_108').prop('disabled', true);
                $('#input_3_109').prop('disabled', true);
                $('#input_3_110').prop('disabled', true);
              }
            }

            // How many years of experience do you have as a medical courier?
            if ($(this)[0].id == 'input_3_96') {
              if ($(this).val() == 'Blood Bank' || $(this).val() == 'Hospital' || $(this).val() == 'Laboratory' || $(this).val() == 'Pharmacy' || $(this).val() == 'Medical Courier Service' || $(this).val() == 'Other') {
                $('#field_3_36').show();
                $('#input_3_36').prop('disabled', false);
              } else {
                $('#field_3_36').hide();
                $('#input_3_36').prop('disabled', true);
              }
            }
            /*if ($(this)[0].id == 'input_3_96') {
                if ($(this).val() == 'No') {
                    $('#field_3_63').hide();
                    $('#input_3_63').prop('disabled', true);
                } else {
                    $('#field_3_63').show();
                    $('#input_3_63').prop('disabled', false);
                }
            }*/

            if ($(this)[0].id == 'input_3_20') {
              if ($(this).val() == 'No') {
                haveLegalRight = false;
              } else {
                haveLegalRight = true;
              }
              checkIfNext();
            }
            if ($(this)[0].id == 'input_3_72') {
              if ($(this).val() == 'No') {
                validDriverLicense = false;
              } else {
                validDriverLicense = true;
              }
              checkIfNext();
            }

            // onboarding form
            //Custom user title
            if ($(this)[0].id == 'input_4_56') {
              if ($(this).val() == 'Other') {
                $('#field_4_57').show();
                $('#input_4_57').prop('disabled', false);
              } else {
                $('#field_4_57').hide();
                $('#input_4_57').prop('disabled', true);
              }
            }
            if ($(this)[0].id == 'input_4_65') {
              if ($(this).val() == 'Other') {
                $('#field_4_66').show();
                $('#input_4_66').prop('disabled', false);
              } else {
                $('#field_4_66').hide();
                $('#input_4_66').prop('disabled', true);
              }
            }
          }
        });
        $('.form select').on('change', function () {
          if ($(this)[0].id == 'input_3_20') {
            if ($(this).find(":selected").val() == 'No') {
              haveLegalRight = false;
            } else {
              haveLegalRight = true;
            }
            checkIfNext();
          }
          if ($(this)[0].id == 'input_3_72') {
            if ($(this).find(":selected").val() == 'No') {
              validDriverLicense = false;
            } else {
              validDriverLicense = true;
            }
            checkIfNext();
          }
        });
        $('.form select').each(function () {
          if ($(this).find(':selected').val() !== '') {
            $(this).closest('.selectric-wrapper').addClass('selectric-changed');

            //Do you have active auto insurance?
            if ($(this)[0].id == 'input_3_29') {
              if ($(this).val() == 'Yes') {
                $(this).closest('.gfield').addClass('has-insurance');
              }
            }
            //Do you have any delivery experience? (0-10+)
            if ($(this)[0].id == 'input_3_93') {
              if ($(this).val() != '0 years') {
                $('#input_3_94').prop('disabled', false);
                $(this).closest('.gfield').addClass('has-experience');
              } else {
                $('#field_3_94').hide();
                $(this).closest('.gfield').removeClass('has-experience');
              }
            }
          }
        });
        $('.form select').on("change", function () {
          if ($(this).find(':selected').val() !== '') {
            $(this).closest('.selectric-wrapper').addClass('selectric-changed');
          }
        });
      }
      if ($(".step-numbers").length > 0) {
        $('.step-numbers__current').text($('.gf_step_active .gf_step_number').text());
        $('.step-numbers__all').text($('.gf_step_last .gf_step_number').text());
      }
      if ($(".step-progress").length > 0) {
        var progress = 100 * Number($('.gf_step_active .gf_step_number').text()) / (Number($('.gf_step_last .gf_step_number').text()) + 1);
        $('.step-progress__status').css('width', progress + '%');
      }

      // onboarding form
      if ($("#gform_wrapper_4").length > 0) {
        var stepsHtml = "<div class=\"step-numbers\">Step\n                        <span class=\"step-numbers__current\">".concat($('.gf_step_active .gf_step_number').text(), "</span>\n                        of\n                        <span class=\"step-numbers__all\">").concat($('.gf_step_last .gf_step_number').text(), "</span>\n                    </div>");
        $('#gform_wrapper_4 .gform_page_footer').append(stepsHtml);
      }

      //hide one error when two are showed
      if ($(".gfield_error .gfield_description.instruction.validation_message").length > 0) {
        $(".gfield_error .gfield_description.instruction.validation_message").closest(".gfield_error").find('.gfield_description.validation_message.gfield_validation_message').hide();
      }
      var countries = ["Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Anguilla", "Antigua and Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bermuda", "Bhutan", "Bolivia", "Bosnia and Herzegovina", "Botswana", "Brazil", "British Virgin Islands", "Brunei", "Bulgaria", "Burkina Faso", "Burundi", "Cambodia", "Cameroon", "Canada", "Cape Verde", "Cayman Islands", "Central Arfrican Republic", "Chad", "Chile", "China", "Colombia", "Congo", "Cook Islands", "Costa Rica", "Cote D Ivoire", "Croatia", "Cuba", "Curacao", "Cyprus", "Czechia", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Ethiopia", "Falkland Islands", "Faroe Islands", "Fiji", "Finland", "France", "French Polynesia", "French West Indies", "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Gibraltar", "Greece", "Greenland", "Grenada", "Guam", "Guatemala", "Guernsey", "Guinea", "Guinea Bissau", "Guyana", "Haiti", "Honduras", "Hong Kong", "Hungary", "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland", "Isle of Man", "Israel", "Italy", "Jamaica", "Japan", "Jersey", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Kosovo", "Kuwait", "Kyrgyzstan", "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg", "Macau", "Macedonia", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Mauritania", "Mauritius", "Mexico", "Micronesia", "Moldova", "Monaco", "Mongolia", "Montenegro", "Montserrat", "Morocco", "Mozambique", "Myanmar", "Namibia", "Nauro", "Nepal", "Netherlands", "Netherlands Antilles", "New Caledonia", "New Zealand", "Nicaragua", "Niger", "Nigeria", "North Korea", "Norway", "Oman", "Pakistan", "Palau", "Palestine", "Panama", "Papua New Guinea", "Paraguay", "Pery", "Philippines", "Poland", "Portugal", "Puerto Rico", "Qatar", "Reunion", "Romania", "Russia", "Rwanda", "Saint Pierre & Miquelon", "Samoa", "San Marino", "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Korea", "South Sudan", "Spain", "Sri Lanka", "St Kitts & Nevis", "St Lucia", "St Vincent", "Sudan", "Suriname", "Swaziland", "Sweden", "Switzerland", "Syria", "Taiwan", "Tajikistan", "Tanzania", "Thailand", "Timor L'Este", "Togo", "Tonga", "Trinidad & Tobago", "Tunisia", "Turkey", "Turkmenistan", "Turks & Caicos", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States", "Uruguay", "Uzbekistan", "Vanuatu", "Vatican City", "Venezuela", "Vietnam", "Virgin Islands (US)", "Yemen", "Zambia", "Zimbabwe"];
      var states = ['Alabama, AL', 'Alaska, AK', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'];
      var carMake = ['Acura', 'Alfa-Romeo', 'Aston Martin', 'Audi', 'BMW', 'Bentley', 'Buick', 'Cadilac', 'Chevrolet', 'Chrysler', 'Daewoo', 'Daihatsu', 'Dodge', 'Eagle', 'Ferrari', 'Fiat', 'Fisker', 'Ford', 'Freighliner', 'GMC - General Motors Company', 'Genesis', 'Geo', 'Honda', 'Hummer', 'Hyundai', 'Infinity', 'Isuzu', 'Jaguar', 'Jeep', 'Kla', 'Lamborghini', 'Land Rover', 'Lexus', 'Lincoln', 'Lotus', 'Mazda', 'Maserati', 'Maybach', 'McLaren', 'Mercedez-Benz', 'Mercury', 'Mini', 'Mitsubishi', 'Nissan', 'Oldsmobile', 'Panoz', 'Plymouth', 'Polestar', 'Pontiac', 'Porsche', 'Ram', 'Rivian', 'Rolls Royce', 'Saab', 'Saturn', 'Smart', 'Subaru', 'Susuki', 'Tesla', 'Toyota', 'Volkswagen', 'Volvo'];

      /*check states input if exist*/
      if ($("#input_3_17").length > 0) {
        //var statesInput = document.getElementById("input_3_17");

        /*initiate the autocomplete function on the "myInput" element, and pass along the states array as possible autocomplete values:*/
        //autocomplete(statesInput, states);
        /*select text in input when click on input*/
        /*statesInput.addEventListener("click", function (e) {
            this.select();
        });*/
      }
      /*check car Make input if exist*/
      if ($("#input_3_17").length > 0) {
        var carMakeInput1 = document.getElementById("input_3_26");
        var carMakeInput2 = document.getElementById("input_3_76");

        /*initiate the autocomplete function on the "myInput" element, and pass along the carMake array as possible autocomplete values:*/
        autocomplete(carMakeInput1, carMake);
        /*select text in input when click on input*/
        carMakeInput1.addEventListener("click", function (e) {
          this.select();
        });
        autocomplete(carMakeInput2, carMake);
        /*select text in input when click on input*/
        carMakeInput2.addEventListener("click", function (e) {
          this.select();
        });
      }

      // Array of U.S. states with names and abbreviations
      var usStates = [{
        name: 'Alabama',
        abbreviation: 'AL'
      }, {
        name: 'Alaska',
        abbreviation: 'AK'
      }, {
        name: 'Arizona',
        abbreviation: 'AZ'
      }, {
        name: 'Arkansas',
        abbreviation: 'AR'
      }, {
        name: 'California',
        abbreviation: 'CA'
      }, {
        name: 'Colorado',
        abbreviation: 'CO'
      }, {
        name: 'Connecticut',
        abbreviation: 'CT'
      }, {
        name: 'Delaware',
        abbreviation: 'DE'
      }, {
        name: 'District of Columbia',
        abbreviation: 'DC'
      }, {
        name: 'Florida',
        abbreviation: 'FL'
      }, {
        name: 'Georgia',
        abbreviation: 'GA'
      }, {
        name: 'Hawaii',
        abbreviation: 'HI'
      }, {
        name: 'Idaho',
        abbreviation: 'ID'
      }, {
        name: 'Illinois',
        abbreviation: 'IL'
      }, {
        name: 'Indiana',
        abbreviation: 'IN'
      }, {
        name: 'Iowa',
        abbreviation: 'IA'
      }, {
        name: 'Kansas',
        abbreviation: 'KS'
      }, {
        name: 'Kentucky',
        abbreviation: 'KY'
      }, {
        name: 'Louisiana',
        abbreviation: 'LA'
      }, {
        name: 'Maine',
        abbreviation: 'ME'
      }, {
        name: 'Maryland',
        abbreviation: 'MD'
      }, {
        name: 'Massachusetts',
        abbreviation: 'MA'
      }, {
        name: 'Michigan',
        abbreviation: 'MI'
      }, {
        name: 'Minnesota',
        abbreviation: 'MN'
      }, {
        name: 'Mississippi',
        abbreviation: 'MS'
      }, {
        name: 'Missouri',
        abbreviation: 'MO'
      }, {
        name: 'Montana',
        abbreviation: 'MT'
      }, {
        name: 'Nebraska',
        abbreviation: 'NE'
      }, {
        name: 'Nevada',
        abbreviation: 'NV'
      }, {
        name: 'New Hampshire',
        abbreviation: 'NH'
      }, {
        name: 'New Jersey',
        abbreviation: 'NJ'
      }, {
        name: 'New Mexico',
        abbreviation: 'NM'
      }, {
        name: 'New York',
        abbreviation: 'NY'
      }, {
        name: 'North Carolina',
        abbreviation: 'NC'
      }, {
        name: 'North Dakota',
        abbreviation: 'ND'
      }, {
        name: 'Ohio',
        abbreviation: 'OH'
      }, {
        name: 'Oklahoma',
        abbreviation: 'OK'
      }, {
        name: 'Oregon',
        abbreviation: 'OR'
      }, {
        name: 'Pennsylvania',
        abbreviation: 'PA'
      }, {
        name: 'Rhode Island',
        abbreviation: 'RI'
      }, {
        name: 'South Carolina',
        abbreviation: 'SC'
      }, {
        name: 'South Dakota',
        abbreviation: 'SD'
      }, {
        name: 'Tennessee',
        abbreviation: 'TN'
      }, {
        name: 'Texas',
        abbreviation: 'TX'
      }, {
        name: 'Utah',
        abbreviation: 'UT'
      }, {
        name: 'Vermont',
        abbreviation: 'VT'
      }, {
        name: 'Virginia',
        abbreviation: 'VA'
      }, {
        name: 'Washington',
        abbreviation: 'WA'
      }, {
        name: 'West Virginia',
        abbreviation: 'WV'
      }, {
        name: 'Wisconsin',
        abbreviation: 'WI'
      }, {
        name: 'Wyoming',
        abbreviation: 'WY'
      },
      // Території США:
      {
        name: 'American Samoa',
        abbreviation: 'AS'
      }, {
        name: 'Guam',
        abbreviation: 'GU'
      }, {
        name: 'Northern Mariana Islands',
        abbreviation: 'MP'
      }, {
        name: 'Puerto Rico',
        abbreviation: 'PR'
      }, {
        name: 'U.S. Virgin Islands',
        abbreviation: 'VI'
      }];
      setupStateInput('input_3_17');
      setupStateInput('input_4_8');
      setupStateInput('input_6_4'); //License Plate State for Primary Vehicle
      setupStateInput('input_6_20'); //State
      setupStateInput('input_6_37'); //Issuing State
      setupStateInput('input_6_51'); //License Plate State for Secondary Vehicle
    }
  });
})(jQuery);